
define('template!webshopProductsDetailBodyCategoriesTagsView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += 'dfsfs';

}
return __p
};});

